<template>
  <div id="app">    
    <!-- Theatre mode viewer -->
    <div class="adv-theatre"><img class="adv-fullpic"></div>
    <!-- Outer page container -->
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
      <!-- Header section containing logo and menu -->      
      <section-header></section-header>
      <!-- Drawer menu -->
      <section-drawer-menu></section-drawer-menu>
      <!-- inner container -->
      <main class="mdl-layout__content mdl-color--blue-grey-800">
        <router-view class="view"></router-view>  
        <!-- Toast -->
        <div id="snackbar" aria-live="assertive" aria-atomic="true" aria-relevant="text" class="mdl-snackbar mdl-js-snackbar">
          <div class="mdl-snackbar__text"></div>
          <button type="button" class="mdl-snackbar__action"></button>
        </div>
      </main>
    </div>  
  </div>
</template>

<script> 
  import Vue from 'vue'
  import SectionDrawerMenu from './components/SectionDrawerMenu.vue'
  import SectionHeader from './components/SectionHeader.vue'

  var vuefire = require('vuefire')
  var firebase = require('firebase')
  var firebaseui = require('firebaseui')

  Vue.use(firebase)
  Vue.use(vuefire)

  var config = {
    apiKey: "AIzaSyDR2Wq9nsbWjci7DYb3BNiZa1Npv4tBA4E",
    authDomain: "testpix-c5e26.firebaseapp.com",
    databaseURL: "https://testpix-c5e26.firebaseio.com",
    storageBucket: "testpix-c5e26.appspot.com",
  }; 

  window.firebase = firebase;
  window.firebase.initializeApp(config);  

   export default {
      name: 'app',
      data () {
        return {
          msg: 'Welcome to Your Vue.js App'
        }
      },
      components: {
        SectionDrawerMenu,
        SectionHeader
      }
    }

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

section.mdl-grid{
  padding: 25px 15px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #3f51b5;
}
a, a:hover, a:active, a:visited {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?72982fed